
















import Vue from "vue";

interface Props {
  count?: number;
}

export default Vue.extend<{}>({
  name: "JzFilterButton",
  functional: true,
  props: {
    count: { type: Number, default: 0 },
  }
});
